import App, { Container } from 'next/app'
import Head from 'next/head'
import React from 'react'
import withReduxStore from '../lib/with-redux-store'
import { Provider } from 'react-redux'
import Header from '../components/Header';
import { Router } from '../routes'

import '../styles/main.less';

import Loading from 'react-loading-bar'
import 'react-loading-bar/dist/index.css'
import { loadBaseData } from '../redux/actions';

class MyApp extends App {
  static async getInitialProps({ Component, ctx }) {
    if (!ctx.reduxStore.getState().token) {
      ctx.reduxStore.dispatch(await loadBaseData(ctx));
    }

    var pageProps = null;
    if (typeof Component.getInitialProps === 'function') {
      pageProps = await Component.getInitialProps(ctx)
    }

    return { pageProps };
  }

  state = {
    showLoader: false
  }

  componentDidMount() {
    Router.events.on('routeChangeStart', () => this.setState({ showLoader: true }));
    Router.events.on('routeChangeComplete', () => this.setState({ showLoader: false }));
    Router.events.on('routeChangeError', () => this.setState({ showLoader: false }));
  }

  componentWillUnmount() {
    Router.events.off('routeChangeStart');
    Router.events.off('routeChangeComplete');
    Router.events.off('routeChangeError');
  }

  render () {
    const { Component, pageProps, reduxStore } = this.props;
    const { showLoader } = this.state;

    return (
      <Container>
        <Provider store={reduxStore}>
          <div>
            <Head>
              <title>Ayurvedamarket.ru - крупнейший магазин аюрведы, более 1500 аюрведических товаров из Индии. Товары для здоровья, специи и пряности, уход за кожей, книги по аюрведе, товары для йоги купить в Москве. Аюрведа-маркет</title>
              <meta name="viewport" content="initial-scale=1.0, width=device-width" />
            </Head>

            <Loading show={showLoader} showSpinner={false} color="#f18429" />

            <div id="page-wrapper">
              <Header />
              <Component {...pageProps} />
            </div>
          </div>
        </Provider>
      </Container>
    )
  }
}

export default withReduxStore(MyApp)
